import React from "react";
import { CryptoTile, Loader } from "@/components";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "@/types/Api.tsx";
import GenericApi from "@/api/genericApi.tsx";
import { CurrenciesCountQueryKey } from "@/config/constants/QueryKeys.tsx";
import { ApiRoutes } from "@/config/routes/ApiRoutes.tsx";
import { CurrencyCountResponse } from "@/types/Currency.tsx";
import { isBitramp } from "@/utils/utils";

const CryptoList: React.FC = () => {
  const { data: currencies, isLoading } = useQuery<
    ApiResponse<CurrencyCountResponse[]>
  >({
    queryFn: async () =>
      GenericApi.get<CurrencyCountResponse[]>(ApiRoutes.CURRENCIES_COUNT),
    queryKey: [CurrenciesCountQueryKey],
  });

  if (isLoading) {
    return <Loader />;
  }

  if (!currencies || !currencies.data || currencies?.error) {
    return <div className="text-black">No data</div>;
  }

  return (
    <div className="flex h-full justify-start flex-col items-start w-full px-5 gap-4 Container pshadow">
      <div className="flex justify-between items-center w-full py-3">
        <h1 className="Subtitle dark-blue font-[700] text-[1.2rem]">
          Most Transactioned
        </h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="4"
          viewBox="0 0 16 4"
          fill="none"
        >
          <circle cx="2" cy="2" r="2" fill="#202A43" />
          <circle cx="8" cy="2" r="2" fill="#202A43" />
          <circle cx="14" cy="2" r="2" fill="#202A43" />
        </svg>
      </div>
      <div
        className={`${
          isBitramp()
            ? "scrollbar-thumb-[#ee33d9]"
            : "scrollbar-thumb-[#202A43]"
        } crypto-list flex px-3 flex-col max-h-[50rem] overflow-y-scroll w-full gap-2 scrollbar-thin scrollbar-track-gray-100`}
      >
        {currencies?.data?.map((currency, index) => (
          <CryptoTile currency={currency} key={index} />
        ))}
      </div>
    </div>
  );
};

export default CryptoList;
